document.addEventListener('DOMContentLoaded', function() {
  const koseDialog = document.getElementById('k-dialog');
  const koseOpen = document.querySelectorAll('.k_open-dialog-button');
  const koseCloseButtons = document.querySelectorAll('.js-k-closeButton');

  koseOpen.forEach(function(koseOpenButton) {
    koseOpenButton.addEventListener('click', function() {
      koseDialog.showModal();
    });
  });

  koseCloseButtons.forEach(function(koseClose) {
    koseClose.addEventListener('click', function() {
      koseDialog.close();
    });
  });

  koseDialog.addEventListener('click', function(event) {
    if (event.target === koseDialog) {
      koseDialog.close();
    }
  });

  const question1Yes = document.getElementById('k_q1_1');
  const question1No = document.getElementById('k_q1_2');
  const question2Yes = document.getElementById('k_q2_1');
  const question2No = document.getElementById('k_q2_2');
  const question3Yes = document.getElementById('k_q3_1');
  const question3No = document.getElementById('k_q3_2');
  const nextButton = document.querySelector('.js-k-nextButton');
  const againButton = document.querySelector('.js-k-againButton');
  const questionWrapper = document.querySelector('.k-dialog__questionWrapper');
  const resultWrapper = document.querySelector('.k-dialog__resultWrapper');
  const resultComplete = document.querySelector('.k-dialog__result--complete');
  const resultImpossible = document.querySelector('.k-dialog__result--impossible');
  const resultAttention = document.querySelector('.k-dialog__result--attention');

  nextButton.disabled = true;
  nextButton.style.backgroundColor = '#d3d3d3';

  function checkAllAnswered() {
    if ((question1Yes.checked || question1No.checked) &&
        (question2Yes.checked || question2No.checked) &&
        (question3Yes.checked || question3No.checked)) {
      nextButton.disabled = false;
      nextButton.style.backgroundColor = '#121212';
    } else {
      nextButton.disabled = true;
      nextButton.style.backgroundColor = '#d1d5db';
    }
  }

  question1Yes.addEventListener('change', checkAllAnswered);
  question1No.addEventListener('change', checkAllAnswered);
  question2Yes.addEventListener('change', checkAllAnswered);
  question2No.addEventListener('change', checkAllAnswered);
  question3Yes.addEventListener('change', checkAllAnswered);
  question3No.addEventListener('change', checkAllAnswered);

  nextButton.addEventListener('click', function() {
    questionWrapper.style.display = 'none';
    resultWrapper.style.display = 'block';

    // if (question1No.checked && question2No.checked && question3No.checked) {
    //   resultImpossible.style.display = 'block';
    // } else if (question1Yes.checked && question2Yes.checked && question3Yes.checked) {
    //   resultComplete.style.display = 'block';
    // } else {
    //   resultAttention.style.display = 'block';
    // }

        // 修正: 質問1がYESでない場合をNOの場合と同じ挙動にする
        if (!question1Yes.checked || (question1No.checked && question2No.checked && question3No.checked)) {
          resultImpossible.style.display = 'block';
        } else if (question1Yes.checked && question2Yes.checked && question3Yes.checked) {
          resultComplete.style.display = 'block';
        } else {
          resultAttention.style.display = 'block';
        }
  });

  againButton.addEventListener('click', function() {
    resultComplete.style.display = 'none';
    resultImpossible.style.display = 'none';
    resultAttention.style.display = 'none';
    resultWrapper.style.display = 'none';

    question1Yes.checked = false;
    question1No.checked = false;
    question2Yes.checked = false;
    question2No.checked = false;
    question3Yes.checked = false;
    question3No.checked = false;

    nextButton.disabled = true;
    nextButton.style.backgroundColor = '#d3d3d3';

    questionWrapper.style.display = 'block';
  });

  document.querySelectorAll('.product-form__submit').forEach(button => {
    button.addEventListener('click', function() {
      koseDialog.close();
    });
  });
});
